import { render, staticRenderFns } from "./RelayAddManagers.vue?vue&type=template&id=f217ac60&scoped=true&"
import script from "./RelayAddManagers.vue?vue&type=script&lang=ts&"
export * from "./RelayAddManagers.vue?vue&type=script&lang=ts&"
import style0 from "./RelayAddManagers.vue?vue&type=style&index=0&id=f217ac60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f217ac60",
  null
  
)

export default component.exports